import Loader from "react-loader-spinner";
import moment from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import DatePicker from "react-datepicker2";
import { faBroom, faSearch, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Popover, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { deleteCheque, deleteChequeFunction, resetChequeFilters, searchForCheque } from "../store/api/DocumentsAPI";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, PersonBadge, Search } from "react-bootstrap-icons";
import { chequeStatusArray, exportToExcel, setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import { useDispatch, useSelector } from "react-redux";
import ModalAddEditChequeFunctions from "../Components/ModalAddEditChequeFunctions";
import { getPersonInfo } from "../../CRM/store/api/CustomerApi";
import { icon } from "@fortawesome/fontawesome-svg-core";

const SearchCheques = () => {
    const dispatch = useDispatch();
    const frmFilters = useRef();
    const [pending, setPending] = useState(false);
    const { register, handleSubmit } = useForm();
    const [groupByCheq, setGroupByCheq] = useState(true);
    const [statusArray, setStatusArray] = useState([...chequeStatusArray]);
    const [showFilter, setShowFilter] = useState(true);
    const filterData = useSelector(state => state.DocumentReducer.cheqSearchFilters);
    const [modalCheqFunctions, setModalCheqFunctions] = useState({ Show: false });
    const [personInfo, setPEronInfo] = useState(null);
    const dateFilters = useRef({
        CreationDateFrom: filterData?.CreationDateFrom,
        CreationDateTo: filterData?.CreationDateTo,
        DueDateFrom: filterData?.DueDateFrom,
        DueDateTo: filterData?.DueDateTo
    });
    function clearFilters() {
        frmFilters.current.reset();
        dateFilters.current = {};
        dispatch(resetChequeFilters({ Take: 10, Skip: 0 }));
        dispatch(searchForCheque({ Take: 10, Skip: 0 }));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        data.Skip = 0;
        if (Array.isArray(data.GroupByCheque)) {
            data.GroupByCheque = data.GroupByCheque.some(c => c === "on");
        }
        const dueDateFrom = document.getElementsByName("DueDateFrom")[0];
        if (dueDateFrom.value !== "") {
            data.DueDateFrom = dateFilters.current.DueDateFrom;
        }
        const dueDateTo = document.getElementsByName("DueDateTo")[0];
        if (dueDateTo.value !== "") {
            data.DueDateTo = dateFilters.current.DueDateTo;
        }
        const creationDateFrom = document.getElementsByName("CreationDateFrom")[0];
        if (creationDateFrom.value !== "") {
            data.CreationDateFrom = dateFilters.current.CreationDateFrom;
        }
        const creationDateTo = document.getElementsByName("CreationDateTo")[0];
        if (creationDateTo.value !== "") {
            data.CreationDateTo = dateFilters.current.CreationDateTo;
        }
        dispatch(searchForCheque(data));
    }
    function onCheqTypeChanged(e) {
        if (e.target.value === "true") {
            const newArray = chequeStatusArray.filter(s => s.StatusName.includes("in"));
            setStatusArray(newArray);
        }
        else if (e.target.value === "false") {
            const newArray = chequeStatusArray.filter(s => s.StatusName.includes("out"));
            setStatusArray(newArray);
        }
        else if (e.target.value === "") {
            setStatusArray([...chequeStatusArray]);
        }
    }
    function rowClick(row) {
        if (row.ChequeStatus === "White") {
            return;
        }
        const { e, target, ...cheq } = row;
        if (Number(cheq.FunctionID) > 0 || ((cheq.ChequeStatus ?? "") !== "" && (Number(cheq.ChequeID) > 0))) {

            setModalCheqFunctions({
                Show: true,
                FunctionID: cheq.FunctionID,
                ChequeStatus: cheq.ChequeStatus,
                ChequeID: cheq.ChequeID
            })
        }
    }
    const onGroupByChange = (e) => {
        setGroupByCheq(JSON.parse(e.target.value));
    }
    function toExcel() {
        const url = "api/DocumentsAPI/SearchForCheque";
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("ChequesReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function deleteCh(row) {
        const onDelete = (res) => {
            if (res.Data) {
                setErrorDialog(dispatch, "success", 'حذف چک')
                search(filterData);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, 'حذف چک')
            }
        }
        deleteCheque(row.ChequeID, onDelete);
    }
    const getPInfo = async (row) => {
        setPEronInfo("PENDING");
        const result = await getPersonInfo(row.LastAccountID, row.LastAccountCat);
        if (result.Message) {
            setErrorDialog(dispatch, result.Error, "دریافت اطلاعات طرف حساب");
            setPEronInfo(null);
        }
        else if (result.Data) {
            setPEronInfo(result.Data);
        }

    }
    const popPersonInfo = (
        <Popover style={{ width: "400px",minWidth:"400px", fontSize: "12px", fontFamily: "Vazir" }} onClick={e => e.stopPropagation()}>
            <Popover.Content className="bodyStyle">
                <h6>
                    <FontAwesomeIcon icon={faUserCircle} size="lg"/>&nbsp;
                    اطلاعات طرف حساب{personInfo?.PPersonType && <>[{personInfo.PPersonType}]</>}
                    </h6>
                <hr />
                {personInfo === "PENDING" &&
                    < div className="text-center">
                        <Loader width={25} height={25} color="#bb1370" type="BallTriangle" />
                    </div>}
                {personInfo && typeof personInfo === "object" && <table>
                    <tbody>
                        <tr>
                            <td style={{whiteSpace:"nowrap", fontSize:"10px"}}>نام: </td>
                            <td>{personInfo.PersonName}</td>
                        </tr>
                        <tr>
                            <td style={{whiteSpace:"nowrap", fontSize:"10px"}}>تلفن: </td>
                            <td>{personInfo.Phone}</td>
                        </tr>
                        <tr>
                            <td style={{whiteSpace:"nowrap", fontSize:"10px"}}>همراه: </td>
                            <td>{personInfo.Mobile}</td>
                        </tr>
                        <tr>
                            <td style={{whiteSpace:"nowrap", fontSize:"10px"}}>نشانی: </td>
                            <td>{personInfo.PersonAddress}</td>
                        </tr>
                        <tr>
                            <td style={{whiteSpace:"nowrap", fontSize:"10px", paddingLeft:"3px"}}>بدهکار/بستانکار: </td>
                            <td>{personInfo.RemainedAcc?.toLocaleString("en-US")} {personInfo.RemainedAccType}</td>
                        </tr>
                    </tbody>
                </table>}
            </Popover.Content>
        </Popover>
    )
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "شماره چک", colName: "ChequeNumber", showInMobile: true },
        { colTitle: "نام بانک و شعبه", colName: "BankName", showInMobile: true },
        { colTitle: "شماره حساب", colName: "BankAccountNo" },
        { colTitle: "مبلغ چک", colName: "ChequeAmount", colType: "currency" },
        { colTitle: "پشت نمره", colName: "ChequeBackNo" },
        { colTitle: "چک دریافتنی", colName: "IsInput", colType: "boolean" },
        { colTitle: "طرف حساب چک", colName: "LastAccountName", showCondition: () => !groupByCheq },
        { colTitle: (groupByCheq ? "آخرین " : "") + "وضعیت چک", colName: "PChequeStatus" },
        { colTitle: "تاریخ ثبت وضعیت", colName: "PCreationDate", showCondition: () => !groupByCheq },
        { colTitle: "تاریخ سررسید", colName: "PDueDate" }
    ]
    const tableRowButtons = [

        {
            title: "حذف چک", type: "delete", className: "group-Btn-smalll btn-danger", showCondition: (item) => item.ChequeStatus === "White",
            onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف چک',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteCh(item)
                }))
            }
        },
        {
            title: "اطلاعات طرف حساب",
            tooltip: "اطلاعات طرف حساب",
            hasTooltip: true,
            icon: <PersonBadge color="#36658f" className="rowBtn" size={18}/>,
            type: "overlay",
            overlay: popPersonInfo,
            className: "group-Btn btn-info",
            showCondition: (item) => !groupByCheq && item.LastAccountID && [3,4,5].includes(item.LastAccountCat),
            onclick: getPInfo
        }

    ]

    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;
                    جستجوی چک
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalAddEditChequeFunctions popData={modalCheqFunctions} setPopData={setModalCheqFunctions} />
                    <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>نوع چک: </label>
                                <select className="search-input" name="IsInput" ref={register({})} onChange={onCheqTypeChanged}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={true}>چک های دریافتنی</option>
                                    <option value={false}>چک های پرداختنی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت چک: </label>
                                <select className="search-input" name="ChequeStatus" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(statusArray) && statusArray.map((sa, i) => <option value={sa.StatusName} key={i}>{sa.StatusTitle}</option>)}
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره چک: </label>
                                <input className="search-input" name="ChequeNumber" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره حساب</label>
                                <input className="search-input" name="BankAccountNo" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>بانک صادر کننده: </label>
                                <input className="search-input" name="BankName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام طرف حساب: </label>
                                <input className="search-input" name="AccountName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مبلغ چک: </label>
                                <input className="search-input" type="number" name="ChequeAmount" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>سررسید از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="DueDateFrom"
                                    value={dateFilters.current.DueDateFrom ? moment(dateFilters.current.DueDateFrom) : null}
                                    onChange={val => dateFilters.current.DueDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group" >
                                <label>سررسید تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="DueDateTo"
                                    value={dateFilters.current.DueDateTo ? moment(dateFilters.current.DueDateTo) : null}
                                    onChange={val => dateFilters.current.DueDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>ثبت از:</label>
                                {dateFilters.current &&
                                    <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateFrom"
                                        value={dateFilters.current.CreationDateFrom ? moment(dateFilters.current.CreationDateFrom) : null}
                                        onChange={val => dateFilters.current.CreationDateFrom = val.local("en").format("YYYY-MM-DD")} />}
                            </Col>
                            <Col md={2} className="form-group" >
                                <label>ثبت تا:</label>
                                {dateFilters.current &&
                                    <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateTo"
                                        value={dateFilters.current.CreationDateTo ? moment(dateFilters.current.CreationDateTo) : null}
                                        onChange={val => dateFilters.current.CreationDateTo = val.local("en").format("YYYY-MM-DD")} />}
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="search-input" defaultValue={10} ref={register({})} name="Take">
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10 ردیف</option>
                                    <option value={20}>20 ردیف</option>
                                    <option value={50}>50 ردیف</option>
                                    <option value={100}>100 ردیف</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرتب سازی براساس: </label>
                                <select className="search-input" name="OrderBy" ref={register({})} defaultValue="CreationDate">
                                    <option value="DueDate">تاریخ سررسید-صعودی</option>
                                    <option value="DueDate DESC">تاریخ سررسید-نزولی</option>
                                    <option value="CreationDate">تاریخ ثبت-صعودی</option>
                                    <option value="CreationDate DESC">تاریخ ثبت-نزولی</option>
                                    <option value="LastAccountName">طرف حساب</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نحوه نمایش: </label>
                                <select className="search-input" ref={register({})} name="GroupByCheque" defaultValue="true" onChange={onGroupByChange}>
                                    <option value={true}>نمایش به تفکیک چک</option>
                                    <option value={false}>نمایش به تفکیک گردش</option>
                                </select>
                                {/* <div className="rowBorder" style={{ padding: "5px" }}>
                                    <input className="form-check-input" type="checkbox" id="chkGroupByCheq" onChange={e => setGroupByCheq(e.target.checked)} defaultChecked={true} /> &nbsp;
                                    <label htmlFor="chkGroupByCheq" style={{ color: "blue" }}>نمایش به تفکیک چک</label>
                                </div> */}
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="submit"><Search size={18} />&nbsp; جستجوی چک</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} objectName="cheqSearchList" reducerName="DocumentReducer" filterData={filterData} className="mt-1"
                        searchMethod={(data) => dispatch(searchForCheque(data))} hasPaging={true} style={{ whiteSpace: "nowrap" }} rowClick={rowClick} />
                </Card.Body>
            </Card>
        </div>)
}
export default SearchCheques;